/**
 * Toggle TabIndex of elements.
 *
 * @param {HTMLCollection} menu Element to check in from.
 * @param {boolean} active True/False if is active.
 */
const toggleMenuTabIndex = ( menu, active ) => {
    const status = !!active ? 0 : -1;

    [ ...menu?.children ].forEach( item => {

        // Switch link tabindex.
        const link = item.querySelector( 'a' );
        if ( !!link ) {
            link.tabIndex = status;
        }

        // Menu-item has sub-items.
        if ( !!item.classList.contains( 'menu-item-has-children' ) ) {
            const button = item.querySelector( 'button' );
            if ( button ) {
                button.tabIndex = status;
            }

            // Close all sub-sub items.
            const openSubs = item.querySelectorAll('[aria-expanded="true"]');
            if( !! openSubs ){
                openSubs.forEach( btn => btn.click() );
            }
        }

        if ( !!item.classList.contains( 'menu-item--adjust-fontsize' ) ) {
            [ ...item.getElementsByClassName('menu-item--adjust-fontsize__item') ].forEach( btn => btn.tabIndex = status );
        }
    } );
}

/**
 * Toggle TabIndex within elements with ID.
 *
 * @param {string} id Wrapper ID.
 * @param {boolean} active True/False if is active.
 */
const toggleTabIndex = ( id, active ) => {
    const wrapper = document.getElementById( id );
    if ( !!wrapper ) {
        [ ...wrapper.getElementsByTagName( 'a' ) ].forEach( link => link.tabIndex = ! active ? 0 : -1 );
        [ ...wrapper.getElementsByTagName( 'input' ) ].forEach( input => input.tabIndex = ! active ? 0 : -1 );
        [ ...wrapper.getElementsByTagName( 'select' ) ].forEach( input => input.tabIndex = ! active ? 0 : -1 );
        [ ...wrapper.getElementsByClassName( 'btn' ) ].forEach( btn => btn.tabIndex = ! active ? 0 : -1 );
    }
}

export { toggleTabIndex, toggleMenuTabIndex };
